import { TourDefinition } from '../types'

// Explored via Playwright MCP on /profile/preferences.
// data-tour targets:
//   "profile-menu-button"     — AppBar profile avatar (base-layout.tsx)
//   "profile-preferences-tab" — Preferences tab (profile/v4/layout.tsx)

export let notificationPreferencesTour: TourDefinition = {
  id: 'notification-preferences',
  version: 1,
  name: 'Notification Preferences',
  description: 'Learn how to customize your email notification settings.',
  allowInLimited: false,
  completionRoute: '/profile/preferences',
  steps: [
    {
      target: 'body',
      placement: 'center',
      title: 'Customize Your Notifications',
      content:
        'Did you know you can control which email notifications you receive from FOAMfrat Studio? This tour will show you where to manage them.',
      disableBeacon: true,
    },
    {
      target: '[data-tour="profile-menu-button"]',
      placement: 'bottom',
      title: 'Head to Your Profile',
      content:
        "Your notification settings live in your profile. Click Next and we'll take you there.",
      disableBeacon: true,
      navigateTo: '/profile/preferences',
    },
    {
      target: '[data-tour="profile-preferences-tab"]',
      placement: 'bottom',
      title: 'Preferences Tab',
      content:
        'The Preferences tab lets you turn on or off email digests for assignments, credential expirations, and more. Toggle what works for you.',
      disableBeacon: true,
      spotlightClicks: true,
    },
  ],
}
